import config from "utils/config";
import showFlash from "flash-message";
import Translator from "utils/translator";

(function() {
    import("angular").then(angular => {
        var app = angular.module("tapAssetManager");

        app.factory("sharerTwitter", [
            "$http",
            "$interval",
            function($http, $interval) {
                $http.defaults.headers.common["X-Csrf-Token"] = config.get("csrf_token");

                return {
                    post: function(asset, source, status, cb) {
                        var self = this;
                        var payload = {
                            asset: asset,
                            source: source,
                            status: status,
                        };

                        $http
                            .post("/api-stateful/share/twitter/post/", JSON.stringify(payload))
                            .success(function(resp, statuscode) {
                                if (cb) cb();
                            })
                            .error(function(resp, statusCode) {
                                if (statusCode !== 401) return cb("err");
                                payload.cb = cb;
                                self.authorize(payload);
                            });
                    },
                    authorize: function(payload, cb) {
                        var self = this;
                        $http
                            .post("/api-stateful/share/twitter/autorization-url/")
                            .success(function(resp, statuscode) {
                                var wn = window.open(
                                    resp,
                                    "popup",
                                    "width=600,height=700,scrollbars=yes,resizable=yes,toolbar=no,directories=no,location=no,menubar=no,status=no",
                                );

                                if (wn === null) {
                                    showFlash(
                                        "warning",
                                        Translator.trans("asset.sharer.popup_blocked", {}, "TapSiteBundle_Pi"),
                                    );

                                    if (cb) return cb();

                                    return;
                                }

                                window.twitterAuthDone = function() {
                                    if (payload)
                                        return self.post(payload.asset, payload.source, payload.status, payload.cb);

                                    if (cb) return cb(true);
                                };

                                var timer = $interval(checkChild, 500);
                                function checkChild() {
                                    if (wn.closed) {
                                        $interval.cancel(timer);

                                        if (cb) return cb();
                                    }
                                }
                            })
                            .error(function(resp, statusCode) {
                                cb("err");
                            });
                    },
                    getShortUrlLength: function() {
                        if (this.fetchingShortUrlLength || this.shortUrlLength) return;
                        this.fetchingShortUrlLength = true;

                        $http.get("/api-stateful/share/twitter/short-url-length/").success((resp, statuscode) => {
                            this.shortUrlLength = resp;
                            this.fetchingShortUrlLength = false;
                        });
                    },
                    getUserDetails: function(cb) {
                        if (this.userDetails) return cb(null, this.userDetails);
                        var self = this;
                        $http
                            .get("/api-stateful/share/twitter/get-user-details/")
                            .success(function(resp, statuscode) {
                                self.userDetails = resp;
                                cb(null, self.userDetails);
                            })
                            .error(function(resp, statusCode) {
                                if (statusCode !== 401) return cb("err");
                                cb(null, false);
                            });
                    },
                    shortUrlLength: null,
                    userDetails: null,
                };
            },
        ]);
    });
})();
